import { gql } from '@apollo/client'

export const GET_BANNERS_QUERY = gql`
  query getBanners($filter: banners_filter, $translations_filter: banners_translations_filter) {
    banners(filter: $filter) {
      id
      content
      name
      link
      dismissible
      icon {
        id
        title
        width
        height
      }
      translations(filter: $translations_filter) {
        content
        link
      }
    }
  }
`
